<template>
  <div class="wt2-sg wt2-masthead-preview-and-produce">
    <wt-button
      v-if="isStoryboarding"
      icon="wticon-eye"
      type="transparent"
      :disabled="autoSaveInProgress"
      :text="shortcutButtonText"
      @click="onPreviewShortcut"
    />
    <wt-button type="primary" :text="buttonText" @click="onClick" />
    <wt-popover
      class="transitionsPopover"
      ref="transitionsPopover"
      @close="manualToolTipClose"
    >
      Watch the full preview to see your video with transitions
    </wt-popover>
  </div>
</template>

<script>
import app from 'app';
import { mapGetters, mapState } from 'vuex';
import wtStoryDurationAlert from 'v/Masthead/wtStoryDurationAlert';
import wt from '@wochit/embedded';

export default {
  mixins: [wtStoryDurationAlert],

  props: {
    onClick: { type: Function, required: true },
  },

  data() {
    return {
      autoSaveInProgress: false,
      shortcutWorking: false,
    };
  },

  computed: {
    ...mapGetters('user', ['isTemplateSpecialist', 'isImpededTemplatizer']),
    ...mapState('user', ['channelId']),
    ...mapState({
      isTemplate: (state) => state.story?.isTemplate,
    }),

    buttonText() {
      return this.isTemplate && !this.isStoryboarding
        ? app.culture.masthead.previewAndPublishButton
        : app.culture.masthead.previewAndProduceButton;
    },

    shortcutButtonText() {
      return app.culture.masthead.previewShortcutButton;
    },

    isStoryboarding() {
      return this.isTemplate && this.isTemplateSpecialist;
    },

    authenticationPie() {
      if (this.isImpededTemplatizer) {
        const authHeader = sessionStorage.getItem('Authorization');
        return {
          userToken: authHeader.replace('Bearer ', ''),
        };
      } else {
        return { skipLogin: true };
      }
    },
  },

  beforeDestroy() {
    app.stopListening(
      app,
      'story:autosave:progress',
      this.autoSaveProgressChanged
    );
    app.off('showTransitionsPopover', this.showTransitionsPopover);
  },

  mounted: function () {
    app.on('showTransitionsPopover', this.showTransitionsPopover);
    app.listenTo(app, 'story:autosave:progress', this.autoSaveProgressChanged);
  },

  methods: {
    showTransitionsPopover() {
      !app.remoteStash.get('sawTransitionsPopover') &&
        this.$refs.transitionsPopover.show();
    },

    manualToolTipClose() {
      app.remoteStash.set('sawTransitionsPopover', true);
    },

    onPreviewShortcut() {
      if (this.shortcutWorking) {
        return;
      }
      this.shortcutWorking = true;
      this.mixinShowViewInModal({
        type: 'fullscreen',
        closeOnClickOut: true,
        closeOnEscape: true,
        component: {
          template: `
          <div class="wt2-sg shortcut-iframe-modal">
          <div class="-title">
            <div class="line-height-normal title wt2-text-l2">Frame View</div>
            <div data-v-b186ca2e="" class="line-height-normal sub-title wt2-text-s">
              This is how your story will appear on Frame View
            </div>
          </div>
          <div class="shortcut-iframe-container" />
          </div>`,
        },
      }).$on('close', () => {
        this.shortcutWorking = false;
      });

      wt.config({
        clientId: `${this.channelId}`,
        ...this.authenticationPie,
      });
      wt.openVideoEditor({
        containerEl: document.querySelector('.shortcut-iframe-container'),
        envUrl: serverProfile.shortcutSdkUrl,
        linkedFields: app.linkedFieldsSchema,
        organizationId: app.rootStore.state.user.selectedOrganizationId,
        storyboardId: app.storyController.story.get('id'),
        hideNavigation: true,
        noCache: true,
      });
    },

    autoSaveProgressChanged(progressEvent) {
      this.autoSaveInProgress = !!progressEvent.inProgress;
    },
  },
};
</script>

<style scoped lang="scss">
.wt2-masthead-preview-and-produce {
  display: flex;
  align-items: stretch;
  position: relative;
}
.transitionsPopover {
  top: 35px;
  right: 10px;
  width: 290px;
}
</style>

<style lang="scss">
.shortcut-iframe-modal {
  display: flex;
  flex-direction: column;
  height: 100%;
  .-title {
    padding: 20px;
  }
  .shortcut-iframe-container {
    flex-grow: 1;
    iframe {
      height: 100%;
      width: 100%;
      border: none;
    }
  }
}
</style>
